import React from "react";
import { HelpCircle, ChevronDown } from "lucide-react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";

export const FAQS = [
  {
    q: "How can I rent a bike in Udupi from RR Bros Bike Rental?",
    a: "You can rent a bike in Udupi by using the Search panel on our homepage (choose pickup point, date and time) or by calling +91 70677 06719. Visit our Udupi branch at Karavali Junction, Karthik Trade Centre, opposite the new KSRTC Bus Stop, complete quick verification and ride out in minutes.",
  },
  {
    q: "Do you offer scooty rental in Manipal for students?",
    a: "Yes, RR Bros offers scooty rental in Manipal. We provide daily, weekly and monthly rentals of Honda Activa 6G, Yamaha Fascino and Yamaha Ray-Z at our Manipal branch on End Point Road, next to Country INN. Students can rent with a valid driving license and college ID.",
  },
  {
    q: "What documents are required for two wheeler rental in Udupi?",
    a: "You need a valid Indian two-wheeler driving license, a government photo ID (Aadhaar, Passport or Voter ID) and, for students, a valid college / hostel ID. A refundable security deposit is collected before every rental.",
  },
  {
    q: "How much does it cost to rent a bike in Udupi or Manipal?",
    a: "Prices vary based on the scooter model and rental duration (daily, weekly or monthly). Use the Search panel on our homepage — enter pickup point, dates and times — to see live rates, or call +91 70677 06719 for a quick quote.",
  },
  {
    q: "Which scooters are available for rent at RR Bros?",
    a: "Our fleet currently includes Honda Activa 6G (110cc, 45 km/l), Yamaha Fascino 125 (125cc, 50 km/l) and Yamaha Ray-Z (113cc, 48 km/l). All scooters are well maintained and serviced regularly at authorised service centres.",
  },
  {
    q: "Is a helmet provided with the bike rental?",
    a: "Yes, one helmet is provided free of cost with every rental. An extra helmet is available at Rs 50/day. Wearing a helmet is mandatory as per Indian traffic laws.",
  },
  {
    q: "Do you provide self drive bike rental in Udupi?",
    a: "Yes, all our rentals are self-drive. Once verification is done, the scooter is yours to ride for the agreed rental period. There is no chauffeur service.",
  },
  {
    q: "Is pickup and drop-off available?",
    a: "Pickup and drop-off service is not currently available. Rentals must be picked up and returned at our Udupi or Manipal branch during office timings (Udupi 07:30 AM \u2013 07:30 PM, Manipal 09:00 AM \u2013 07:30 PM).",
  },
];

const FAQ = () => {
  return (
    <section id="faq" className="py-16 lg:py-24 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10">
          <span className="text-orange-600 font-bold text-sm uppercase tracking-[0.2em]">
            FAQ
          </span>
          <h2 className="mt-3 text-4xl sm:text-5xl font-black text-neutral-900 leading-tight tracking-tight">
            Frequently Asked <span className="text-orange-500">Questions</span>
          </h2>
          <p className="mt-4 text-neutral-600 max-w-2xl mx-auto">
            Everything you need to know about bike rental in Udupi and scooty
            rental in Manipal with RR Bros.
          </p>
        </div>

        <Accordion type="single" collapsible className="space-y-3">
          {FAQS.map((f, idx) => (
            <AccordionItem
              key={idx}
              value={`item-${idx}`}
              className="bg-neutral-50 border border-neutral-100 rounded-2xl px-5 sm:px-6 overflow-hidden"
            >
              <AccordionTrigger className="text-left font-bold text-neutral-900 hover:no-underline py-5 [&[data-state=open]>svg]:text-orange-500">
                <div className="flex items-start gap-3 pr-3">
                  <HelpCircle className="w-5 h-5 text-orange-500 mt-0.5 flex-shrink-0" />
                  <span className="text-sm sm:text-base">{f.q}</span>
                </div>
              </AccordionTrigger>
              <AccordionContent className="text-neutral-700 leading-relaxed text-sm sm:text-base pl-8 pb-5">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQ;
